module.exports = __webpack_public_path__ + "img/Globe.62d77695.svg";